import { render } from "./RightDrawer.vue?vue&type=template&id=235b6643&ts=true"
import script from "./RightDrawer.vue?vue&type=script&lang=ts"
export * from "./RightDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__